import * as React from 'react'

import { TagDiv } from './styles'

export interface TagProps {
  text: string
}

const Tag = ({ text }: TagProps) => {
  return <TagDiv id="nova-shared-Tag-root">{text}</TagDiv>
}

export default Tag
